module.exports = __webpack_public_path__ + "img/laptop-icon.546534d8.svg";